module.exports = __webpack_public_path__ + "img/step1.c2866379.png";